export class RedirectModal {

    M2 = (window as any).M2;

    private _config = {
        isRedirect: false,
        message: "",
        cookieName: "ShowRedirectPopup"
    };

    constructor(props) {
        this.redirectStatus = Boolean(this.getCookieStatus(this.cookieName));
        this.modalMessage = props.message;
        if (this.redirectStatus) {
            this.openModal(props.title, props.message);
            this.deleteCookie(this.cookieName);
        }
    }
    get cookieName() {
        return this._config.cookieName;
    }

    get redirectStatus() {
        return this._config.isRedirect;
    }

    set redirectStatus(state) {
        this._config.isRedirect = state;
    }

    get modalMessage() {
        return this._config.message;
    }

    set modalMessage(msg) {
        this._config.message = msg;
    }

    openModal(modalTitle, modalMessage) {
        this.M2.Modal.create("redirect", modalTitle, "<p class=''>" + modalMessage + "</p>", "modal-md", true);
    }

    getCookieStatus(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    // Access to post redirect method
    onSuccess() { }


}